import * as React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import CyPortfolioCalendarYearReturnTable from "../../../components/Charts/CyPortfolioCalendarYearReturnTable";

const StrategyCalendarYearReturn = (props) => {
  const { portfolio, benchmarkName } = props;
  const { cprRecommendation } = portfolio;

  return (
    <section className={"content"}>
      <Grid
        container={true}
        spacing={3}
        className={"sub-content"}
        data-toc={"Calendar Year Returns"}
      >
        <Grid item={true} xs={12}>
          <Typography variant="h4">
            Cy Optimized Portfolio Annualized Performance
          </Typography>
          <Typography variant="h5" gutterBottom={true}>
            Hypothetical Illustration
          </Typography>
        </Grid>
        <Grid item={true} xs={12}>
          <Typography variant="h5">
            Cy Optimized Portfolio Calendar Year Returns
          </Typography>
          <Typography variant="h6" gutterBottom={true}>
            Percentage Return (%)
          </Typography>
        </Grid>
        <Grid item={true} xs={12}>
          <CyPortfolioCalendarYearReturnTable
            portfolioDisplayName={cprRecommendation.displayName || ""}
            calendarYearReturnData={cprRecommendation.calendarYearReturn}
            showPercentageSign={false}
            benchmarkName={benchmarkName}
            arraySplitIndex={23}
          />
        </Grid>
      </Grid>
    </section>
  );
};


export default StrategyCalendarYearReturn;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/StrategyCalendarYearReturn.jsx